
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.688 6.493c.4-.312.897-.493 1.427-.493h9.77c.53 0 1.028.18 1.427.493.4.313.7.755.833 1.279l1.576 6.197A9.05 9.05 0 0121 16.2c0 .5-.2.95-.524 1.276a1.758 1.758 0 01-2.509 0c-.254-.257-.673-.912-1.076-1.616a31.931 31.931 0 01-.617-1.136l-.037-.072-.01-.018-.002-.005-.278-.549H8.054l-.278.546-.003.005-.009.018-.037.07a30.262 30.262 0 01-.614 1.12c-.401.694-.827 1.352-1.099 1.627-.35.352-.774.534-1.236.534-.489 0-.931-.198-1.254-.524A1.802 1.802 0 013 16.23c.038-1.053.13-1.672.28-2.261l1.576-6.197c.133-.524.433-.966.832-1.279zm9.467 10.359c-.162-.285-.309-.553-.426-.772h-5.46c-.116.216-.262.48-.424.76-.381.66-.927 1.547-1.41 2.034C6.734 19.578 5.81 20 4.777 20a3.758 3.758 0 01-2.674-1.116A3.802 3.802 0 011 16.224v-.04c.041-1.169.146-1.94.341-2.709L2.917 7.28a4.357 4.357 0 011.539-2.361A4.311 4.311 0 017.116 4h9.769c.991 0 1.92.339 2.66.918a4.356 4.356 0 011.538 2.36l1.576 6.198c.227.89.341 1.805.341 2.724a3.802 3.802 0 01-1.104 2.684 3.758 3.758 0 01-5.348 0c-.472-.476-1.015-1.37-1.393-2.032zM10 10a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm7 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z","fill":"currentColor"}})])
          )
        }
      }
    